<ng-template #templateRef>
  <form #editorForm="ngForm" (ngSubmit)="save()" id="locationEditor" name="editRelation">
    <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} stock date</h2>
    <mat-dialog-content *ngIf="Copy">
      <div class="row">
        <div class="col-md-6">
          <app-dropdown-option [(ngModel)]="Copy.SupplyPlant" [required]="true" discriminator="SupplyPlant"
                               model="Address"
                               name="Type" placeholder="Supply Plant"></app-dropdown-option>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>In stock date</mat-label>
            <input [(ngModel)]="Copy.InStockDate " [matDatepicker]="picker3" matInput
                   name="InStockDate">
            <mat-datepicker-toggle [for]="picker3" matIconSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker3 [startAt]="Copy.InStockDate"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="fill-remaining-space"></div>
      <button mat-button mat-dialog-close mat-raised-button type="button">Close</button>
      <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
    </mat-dialog-actions>
  </form>
</ng-template>
